// extracted by mini-css-extract-plugin
export default {"descriptionTerm":"DescriptionTerm_descriptionTerm__XVudt","compact":"DescriptionTerm_compact__DJSyb"};